export default __webpack_public_path__ + "static/media/39.25e04f07.jpg";